// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const NETWORKS_POST_REQUEST = 'NETWORKS_POST_REQUEST';
// prettier-ignore
export const NETWORKS_POST_REQUEST_SUCCESS = 'NETWORKS_POST_REQUEST_SUCCESS';
// prettier-ignore
export const NETWORKS_POST_REQUEST_FAILURE = 'NETWORKS_POST_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORKS_POST_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: NETWORKS_POST_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: NETWORKS_POST_REQUEST_FAILURE,
    error,
  };
}
